import * as $ from 'jquery';

export function print(content: string, chapterName?: string): void {
    const printWindow = createWindow();
    let title = $('.document_header').data('title');
    let subheader = $('.doktyp').data('subheader');

    if (isNotUndefinedOrEmpty(chapterName)) {
        title = `Utdrag ur ${title} - ${chapterName}`;
    }

    printWindow.document.write(generateOutput(content, title, subheader));
    printWindow.document.close();
};

(window as any)._printContent = print;

function isNotUndefinedOrEmpty(str: string): boolean {
    return typeof (str) === 'string' && str.length > 0;
}

function createWindow(): any {
    return window.open(
        'about:blank',
        `print${(new Date()).getTime()}`,
        'scrollbars=1,width=1000,height=700'
    );
}

function generateOutput(content: string, title: string, subheader: string): string {
    return `
        <!DOCTYPE html>
        <html>
            <head>
                <meta http-equiv='X-UA-Compatible' content='IE=edge,chrome=1'>
                <meta charset='utf- 8' />
                <title>FAR Online</title>
                <link type='text/css' href='/assets/css/site.css' rel='stylesheet' />
            </head>
            <body class='print-information'>
                <form id='form' action='/pdf/print/' method='POST' accept-charset='UTF-8'>
                    ${$(`<div>`).append($(`<input type="hidden" name="content" />`).val(content)).html()}
                    ${$(`<div>`).append($(`<input type="hidden" name="title" />`).val(title)).html()}
                    ${$(`<div>`).append($(`<input type="hidden" name="subheader" />`).val(subheader)).html()}
                    <div class='print-information__message'>
                        Din PDF genereras nu. Om den inte automatiskt visas inom ca 5-10 sekunder; tryck på knappen nedan.
                    </div>
                    <input type='submit' class='print-information__button' value='Skriv ut' />
                </form>
                <script type=\"text/javascript\">document.getElementById('form').submit();</script>
            </body>
        </html>
    `;
}